type GrammarMatrixCellKc = {
  name?: string;
  strapiWordId?: string | null;
};

type GrammarMatrix = {
  cells?: Record<string, Record<string, GrammarMatrixCellKc[]>>;
};

/**
 * Builds the display model for a published Grammar KC that has not yet been
 * added to the student's progress record. It deliberately has no history: the
 * matrix is the curriculum source of truth for its name and level.
 */
export function findGrammarCurriculumKc(matrix: GrammarMatrix | null | undefined, kcId: string) {
  if (!matrix?.cells || !kcId) return null;

  for (const levels of Object.values(matrix.cells)) {
    for (const [level, kcs] of Object.entries(levels || {})) {
      const kc = Array.isArray(kcs)
        ? kcs.find(item => item?.strapiWordId != null && String(item.strapiWordId) === String(kcId))
        : null;

      if (kc) {
        return {
          name: kc.name || "Grammar knowledge component",
          status: "not_yet_seen",
          strapiWordId: String(kc.strapiWordId),
          level: Number(level) || null,
          exposureHistory: []
        };
      }
    }
  }

  return null;
}
